import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getActiveFilters = (state: ContentPluginRootState) => state.data.activeFilters || {};

export default getActiveFilters;
